/**
 * @flow
 * @relayHash 49276b054204a03e96138c2172bd8c75
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getEventsQueryVariables = {|
  propertyId: string,
  startAt?: ?string,
  endAt?: ?string,
  status?: ?string,
  search?: ?string,
  last?: ?number,
  before?: ?string,
  type?: ?string,
|};
export type getEventsQueryResponse = {|
  +hyevents: {|
    +pageInfo: {|
      +endCursor: ?string,
      +startCursor: ?string,
      +hasPreviousPage: boolean,
      +hasNextPage: boolean,
    |},
    +edges: $ReadOnlyArray<?{|
      +cursor: ?string,
      +node: ?{|
        +id: string,
        +title: string,
        +maxNoOfGuests: number,
        +additionalGuestAllowed: boolean,
        +maxAdditionalGuests: ?number,
        +ctaText: string,
        +messageTitle: string,
        +message: string,
        +address: string,
        +placeName: string,
        +status: string,
        +propertyId: string,
        +startAt: any,
        +endAt: any,
        +publishAt: ?any,
        +inviteScheduledAt: ?any,
        +cancelReason: ?string,
        +rsvpedCount: number,
        +inviteEmailCampaignId: ?string,
        +cancelEmailCampaignId: ?string,
        +rescheduleEmailCampaignId: ?string,
        +nightReminderEmailCampaignId: ?string,
        +morningReminderEmailCampaignId: ?string,
        +rsvpedCampaignId: ?string,
        +rsvpCancelledCampaignId: ?string,
        +waitlistedCampaignId: ?string,
        +waitlistOpeningCampaignId: ?string,
        +image: {|
          +id: string,
          +fileType: string,
          +fileSize: number,
          +fileUrl: string,
          +dimension: ?string,
          +thumbnailUrl: ?string,
        |},
        +eventType: string,
        +displayTime: ?string,
        +zoomLink: string,
        +meetingId: string,
        +passcode: string,
        +smsEnabled: ?boolean,
        +recurringEventType: ?string,
        +invitedGroups: ?string,
      |},
    |}>,
  |}
|};
export type getEventsQuery = {|
  variables: getEventsQueryVariables,
  response: getEventsQueryResponse,
|};
*/


/*
query getEventsQuery(
  $propertyId: ID!
  $startAt: String
  $endAt: String
  $status: String
  $search: String
  $last: Int
  $before: String
  $type: String
) {
  hyevents(propertyId: $propertyId, startAt: $startAt, endAt: $endAt, status: $status, search: $search, last: $last, before: $before, type: $type) {
    pageInfo {
      endCursor
      startCursor
      hasPreviousPage
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        title
        maxNoOfGuests
        additionalGuestAllowed
        maxAdditionalGuests
        ctaText
        messageTitle
        message
        address
        placeName
        status
        propertyId
        startAt
        endAt
        publishAt
        inviteScheduledAt
        cancelReason
        rsvpedCount
        inviteEmailCampaignId
        cancelEmailCampaignId
        rescheduleEmailCampaignId
        nightReminderEmailCampaignId
        morningReminderEmailCampaignId
        rsvpedCampaignId
        rsvpCancelledCampaignId
        waitlistedCampaignId
        waitlistOpeningCampaignId
        image {
          id
          fileType
          fileSize
          fileUrl
          dimension
          thumbnailUrl
        }
        eventType
        displayTime
        zoomLink
        meetingId
        passcode
        smsEnabled
        recurringEventType
        invitedGroups
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "propertyId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "startAt",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "endAt",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "status",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "last",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "before",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "hyevents",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
      },
      {
        "kind": "Variable",
        "name": "endAt",
        "variableName": "endAt"
      },
      {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
      },
      {
        "kind": "Variable",
        "name": "propertyId",
        "variableName": "propertyId"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "startAt",
        "variableName": "startAt"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      },
      {
        "kind": "Variable",
        "name": "type",
        "variableName": "type"
      }
    ],
    "concreteType": "Hyevents",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "pageInfo",
        "storageKey": null,
        "args": null,
        "concreteType": "PageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "endCursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "startCursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasPreviousPage",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "hasNextPage",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "EventNode",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "cursor",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Hyevent",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "maxNoOfGuests",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "additionalGuestAllowed",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "maxAdditionalGuests",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "ctaText",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "messageTitle",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "message",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "address",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "placeName",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "status",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "propertyId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "publishAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "inviteScheduledAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cancelReason",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rsvpedCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "inviteEmailCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cancelEmailCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rescheduleEmailCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "nightReminderEmailCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "morningReminderEmailCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rsvpedCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "rsvpCancelledCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "waitlistedCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "waitlistOpeningCampaignId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "image",
                "storageKey": null,
                "args": null,
                "concreteType": "Asset",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fileType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fileSize",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fileUrl",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dimension",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "thumbnailUrl",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "eventType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "displayTime",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "zoomLink",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "meetingId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "passcode",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "smsEnabled",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "recurringEventType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "invitedGroups",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getEventsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getEventsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getEventsQuery",
    "id": null,
    "text": "query getEventsQuery(\n  $propertyId: ID!\n  $startAt: String\n  $endAt: String\n  $status: String\n  $search: String\n  $last: Int\n  $before: String\n  $type: String\n) {\n  hyevents(propertyId: $propertyId, startAt: $startAt, endAt: $endAt, status: $status, search: $search, last: $last, before: $before, type: $type) {\n    pageInfo {\n      endCursor\n      startCursor\n      hasPreviousPage\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        title\n        maxNoOfGuests\n        additionalGuestAllowed\n        maxAdditionalGuests\n        ctaText\n        messageTitle\n        message\n        address\n        placeName\n        status\n        propertyId\n        startAt\n        endAt\n        publishAt\n        inviteScheduledAt\n        cancelReason\n        rsvpedCount\n        inviteEmailCampaignId\n        cancelEmailCampaignId\n        rescheduleEmailCampaignId\n        nightReminderEmailCampaignId\n        morningReminderEmailCampaignId\n        rsvpedCampaignId\n        rsvpCancelledCampaignId\n        waitlistedCampaignId\n        waitlistOpeningCampaignId\n        image {\n          id\n          fileType\n          fileSize\n          fileUrl\n          dimension\n          thumbnailUrl\n        }\n        eventType\n        displayTime\n        zoomLink\n        meetingId\n        passcode\n        smsEnabled\n        recurringEventType\n        facebookShareUrl\n        invitedGroups\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd26ad19f79d6ab966ad585efcabfc715';
module.exports = node;
